import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const Skills = () => {
    const leftColStyle = {
        fontWeight: "bold",
        fontSize: {
            xs: "20px",
            sm: "25px",
        },
        textAlign: {
            xs: "center",
            sm: "right",
        },
        justifyContent: "center",
        color: {
            xs: "#5ce2e2",
            sm: "#fff",
        },
    };

    const rightColStyle = {
        textAlign: {
            xs: "center",
            sm: "left",
        },
        verticalAlign: {
            xs: "text-top",
            sm: "center",
        },
        fontSize: {
            xs: "18px",
            sm: "25px",
        },
    };

    return (
        <React.Fragment>
            <a id="skills" />
            <Box
                sx={{
                    p: 5,
                    pt: 10,
                    backgroundImage: "url('/imgs/nightSkySection.jpg')",
                    backgroundAttachment: "fixed",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    // Image Source: Photo by eberhard grossgasteiger: https://www.pexels.com/photo/canion-mountains-on-night-sky-2098428/</React.Fragment>
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        color: "#5ce2e2",
                        fontWeight: "bold",
                        textShadow:
                            "1px 1px 1px #919191, 1px 2px 1px #919191,1px 3px 1px #919191",
                    }}
                >
                    Skills
                </Typography>
                <Box sx={{ color: "#fff", my: 7 }}>
                    <Grid
                        container
                        justifyContent="center"
                        rowSpacing={{ xs: 2, sm: 10 }}
                        columnSpacing={10}
                        sx={{ p: 2 }}
                    >
                        <Grid item xs={12} sm={5} sx={leftColStyle}>
                            Languages & Development
                        </Grid>
                        <Grid item xs={12} sm={7} sx={rightColStyle}>
                            JavaScript, ServiceNow platform scripting, Python, C# (foundational knowledge), REST APIs
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        rowSpacing={{ xs: 2, sm: 10 }}
                        columnSpacing={10}
                        sx={{ p: 2 }}
                    >
                        <Grid item xs={12} sm={5} sx={leftColStyle}>
                            Frameworks & Platforms
                        </Grid>
                        <Grid item xs={12} sm={7} sx={rightColStyle}>
                            ServiceNow, React, Node.js, Express, Flask
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        rowSpacing={{ xs: 2, sm: 10 }}
                        columnSpacing={10}
                        sx={{ p: 2 }}
                    >
                        <Grid item xs={12} sm={5} sx={leftColStyle}>
                            Data & Analytics
                        </Grid>
                        <Grid item xs={12} sm={7} sx={rightColStyle}>
                            Splunk dashboard development, operational reporting, data validation automation
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        rowSpacing={{ xs: 2, sm: 10 }}
                        columnSpacing={10}
                        sx={{ p: 2 }}
                    >
                        <Grid item xs={12} sm={5} sx={leftColStyle}>
                            Monitoring & Observability
                        </Grid>
                        <Grid item xs={12} sm={7} sx={rightColStyle}>
                            ScienceLogic SL1, LogicMonitor
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        rowSpacing={{ xs: 2, sm: 10 }}
                        columnSpacing={10}
                        sx={{ p: 2 }}
                    >
                        <Grid item xs={12} sm={5} sx={leftColStyle}>
                            Databases
                        </Grid>
                        <Grid item xs={12} sm={7} sx={rightColStyle}>
                            MongoDB, MySQL, CMDB data modeling
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        rowSpacing={{ xs: 2, sm: 10 }}
                        columnSpacing={10}
                        sx={{ p: 2 }}
                    >
                        <Grid item xs={12} sm={5} sx={leftColStyle}>
                            Tools & Practices
                        </Grid>
                        <Grid item xs={12} sm={7} sx={rightColStyle}>
                            Git, Agile development, UAT strategy, release coordination, workflow automation
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </React.Fragment>
    );
};

export default Skills;
